import classNames from "classnames";
import { useState } from "react";

export type ButtonProps<T> = {
	value: T;
	label: string | JSX.Element;
	props?: React.HTMLProps<HTMLButtonElement>;
	disable_selected_state?: boolean;
};

export function SeshAddonInput<T>(props: {
	label?: string | JSX.Element;
	value?: T;
	setValue: (new_value: T) => void;
	buttons: ButtonProps<T>[];
	is_disabled?: boolean;
	size?: "sm" | "md";
}) {
	const size = props.size ?? "md";
	return (
		<>
			{props.label && <label className="label">{props.label}</label>}
			<div className="flex">
				{props.buttons.map((val, index) => {
					return (
						<button
							key={index}
							{...val.props}
							className={classNames(
								"border border-sesh-dark font-bold",
								{
									"bg-sesh-dark text-base-dark":
										val.value === props.value &&
										!val.disable_selected_state,
									"bg-base-dark text-white hover:bg-base-light":
										val.value !== props.value ||
										val.disable_selected_state,
									"rounded-l-md": index === 0,
									"rounded-r-md":
										index === props.buttons.length - 1,
									"input-disabled": props.is_disabled,
									"h-fit p-2 text-sm": size === "sm",
									"px-2 py-2 text-sm sm:h-10 sm:px-4 sm:text-base":
										size === "md",
								}
							)}
							type="button"
							onClick={() =>
								!props.is_disabled && props.setValue(val.value)
							}
						>
							<p>{val.label}</p>
						</button>
					);
				})}
			</div>
		</>
	);
}
